module.exports = __webpack_public_path__ + "static/media/intro.a22c8a09.png";